export default __webpack_public_path__ + "static/media/bubba.179db48b.png";